import React from 'react';
import styled from 'styled-components';
import ProBadge from './ProBadge';

const ProfileName = styled.h2`
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const ProfileNameWithBadge = ({ name, isPro }) => {
  return (
    <ProfileName>
      {name}
      {isPro && <ProBadge>Pro</ProBadge>}
    </ProfileName>
  );
};

export default ProfileNameWithBadge; 